// extracted by mini-css-extract-plugin
export default {"menuButton":"MenuButton_menuButton__O1a5l","isDisabled":"MenuButton_isDisabled__yB8GN","active":"MenuButton_active__Favx1","menuButtonText":"MenuButton_menuButtonText__aZi-S"};